import { getPolicyStatusInfo } from './calculations.js'

const normalizeBeneficiary = (value) => String(value || '').replace(/\s+/g, '')
const validDeathBenefitStatuses = new Set(['yes', 'no', 'unknown'])

export const normalizeDeathBenefitStatus = (value) => validDeathBenefitStatuses.has(value) ? value : 'unknown'

export const getDeathBenefitStatusLabel = (value) => ({
  yes: '有身故责任',
  no: '无身故责任',
  unknown: '待确认',
}[normalizeDeathBenefitStatus(value)])

export const getBeneficiaryDisplayText = (policy = {}) => {
  const deathBenefitStatus = normalizeDeathBenefitStatus(policy.deathBenefitStatus)
  if (deathBenefitStatus === 'no') return '不适用'
  if (deathBenefitStatus === 'unknown') return '身故责任待确认'
  return String(policy.beneficiary || '').trim() || '法定'
}

export const isLegalBeneficiary = (value) => {
  const normalized = normalizeBeneficiary(value)
  return !normalized || normalized.includes('法定')
}

const hasBeneficiaryChangeCondition = (policy = {}) => {
  const statusCode = policy.statusInfo?.code || getPolicyStatusInfo(policy).code
  return statusCode !== 'lapsed' && normalizeDeathBenefitStatus(policy.deathBenefitStatus) === 'yes' && isLegalBeneficiary(policy.beneficiary)
}

export const needsBeneficiaryChange = (policy = {}) => hasBeneficiaryChangeCondition(policy) && !policy.beneficiaryReminderPaused

export const isBeneficiaryReminderPaused = (policy = {}) => hasBeneficiaryChangeCondition(policy) && Boolean(policy.beneficiaryReminderPaused)

export const getBeneficiaryReminderPolicies = (policies = []) => policies.filter(needsBeneficiaryChange)

export const needsDeathBenefitConfirmation = (policy = {}) => {
  const statusCode = policy.statusInfo?.code || getPolicyStatusInfo(policy).code
  return statusCode !== 'lapsed' && normalizeDeathBenefitStatus(policy.deathBenefitStatus) === 'unknown'
}

export const getDeathBenefitConfirmationPolicies = (policies = []) => policies.filter(needsDeathBenefitConfirmation)

export const mergePendingPolicies = (...groups) => {
  const byId = new Map()
  groups.flat().forEach((policy) => byId.set(policy.id, policy))
  return [...byId.values()]
}
